<div class="modal-wrapper" [@dialog] *ngIf="isVisible$ | async">
  <div class="modal-backdrop" (click)="close(false)"><span></span></div>
  <div class="modal-content video-modal">
    <iframe [src]="videoUrl | async"
      frameborder="0"
      allowfullscreen
      class="video-player">
    </iframe>
  </div>
</div>
